"use client";

import { Copy, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Location() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const landmarks = [{
    label: "· 5 MIN FROM HARTFORD DOWNTOWN"
  }, {
    label: "· 10 MIN FROM I-91 ACCESS"
  }, {
    label: "· ACCESSIBLE PARKING ON-SITE"
  }];
  const hours = [{
    day: "MON",
    time: "8AM – 5PM",
    closed: false
  }, {
    day: "TUE",
    time: "8AM – 5PM",
    closed: false
  }, {
    day: "WED",
    time: "8AM – 5PM",
    closed: false
  }, {
    day: "THU",
    time: "8AM – 5PM",
    closed: false
  }, {
    day: "FRI",
    time: "8AM – 4PM",
    closed: false
  }, {
    day: "SAT",
    time: "CLOSED",
    closed: true
  }, {
    day: "SUN",
    time: "CLOSED",
    closed: true
  }];
  return;
}